module.exports = __webpack_public_path__ + "static/media/steamBox.1aac5d24.png";